import { Card, Tooltip } from "antd";
import React from "react";
import './index.scss'
import { QuestionCircleOutlined } from "@ant-design/icons";

type Iprops = {
  title: string;
  value?: number;
  suffix?: string;
  valueStyle?: React.CSSProperties | undefined;
  tip?: string; 
  onClick?: () => void
}

const Statistic: React.FC<Iprops> = (props) => {
  const { title, value = 0, suffix, valueStyle, tip, onClick = () => {} } = props
  return (
    <div className="statistic-content">
      <Card bordered={false} style={{ background: 'aliceblue' }}>
        <div className="title">
          <span>{ title }</span>
          <Tooltip placement="top" title={tip}>
            {tip && <QuestionCircleOutlined />}
          </Tooltip>
        </div>
        <div className="value-con">
          <span className="value" onClick={() => onClick()} style={valueStyle}>{ value?.toLocaleString() }</span>
          <span className="suffix">{ suffix }</span>
        </div>
      </Card>
    </div>
  )
}

export default Statistic